import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/importar-laudo`

    return {
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        list(queryParms = {}) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        show(queryParms = {}) {

            return repository.get(`${baseUrl}/show?${urlUtil.serialize(queryParms)}`)
        },
        load(queryParms = {}) {

            return repository.get(`${baseUrl}/load?${urlUtil.serialize(queryParms)}`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}/destroy`)
        },
        download(id) {

            return repository.get(`${baseUrl}/${id}/download`, { responseType: "arraybuffer" })
        },
        getExames(id) {

            return repository.get(`${baseUrl}/${id}/get-exame`)
        },
    }
}
